import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';
import { useRef } from 'react';

export const DemMcoPymtPerspective = () => {

  const entityPerspectiveRef = useRef();

  const views = [
    {
      name: 'Managed Care Payments',
      dims: ['PAID_PERIOD', 'EARNED_PERIOD', 'PBM', 'PROD'],
      kpis: ['PYMT_AMT', 'PYMT_ADJ', 'TOTAL_PYMT'],
      dimToPeriodicities: {
        PAID_PERIOD: ['LIFETIME', 'YEAR', 'QTR', 'MON'],
        EARNED_PERIOD: ['YEAR', 'QTR']
      }
    }
  ]

  const getContextMenuItems = (params) => {
    let contextMenus = entityPerspectiveRef.current.getContextMenuItems(params);

    contextMenus.push(
      {
        name: 'Navigate to Transactions',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'PYMT_AMT', 'Transactions')
      },
      {
        name: 'Navigate to Payment Adjustments',
        action: () => entityPerspectiveRef.current.navigateToPerspectiveAdj(params, 'PYMT_ADJ', 'Payment Adjustments')
      },
    )

    return contextMenus;
  }

  return (
    <EntityPerspective
      ref={entityPerspectiveRef}
      views={views}
      gridOptions={{
        getContextMenuItems
      }}
    />
  )
}